/* NEXSORA: friendly currency note shown the moment a customer presses any checkout button. No dependencies. */
(function () {
  'use strict';
  if (window.__nxCurrencyNote) return;
  window.__nxCurrencyNote = true;

  // Every checkout trigger in the theme: cart Checkout, product "Buy It Now" buttons, and any link to /checkout.
  var SEL = '#nx-checkout,#nx-buy-now,[data-sg-buynow],[data-nx-buy],a[href="/checkout"],a[href^="/checkout?"],button[name="checkout"],input[name="checkout"]';
  var bypass = false, modal = null, pending = null, lastFocus = null;

  var CSS = '' +
    '.nxcn{position:fixed;inset:0;z-index:100000;display:none;align-items:center;justify-content:center;padding:18px;background:rgba(5,4,10,.74);-webkit-backdrop-filter:blur(6px);backdrop-filter:blur(6px);font-family:Inter,-apple-system,"Helvetica Neue",Arial,sans-serif}' +
    '.nxcn.is-open{display:flex;animation:nxcn-fade .25s ease both}' +
    '.nxcn__box{position:relative;width:100%;max-width:440px;max-height:calc(100svh - 36px);overflow:auto;background:#0f0d16;color:#f6f4f1;border:1px solid rgba(255,255,255,.14);border-radius:24px;padding:30px 26px 24px;box-shadow:0 40px 100px -30px rgba(0,0,0,.9);animation:nxcn-rise .4s cubic-bezier(.16,1,.3,1) both}' +
    '.nxcn__icon{width:46px;height:46px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:linear-gradient(135deg,rgba(255,154,82,.25),rgba(120,100,255,.25));border:1px solid rgba(255,255,255,.16);margin-bottom:18px}' +
    '.nxcn__title{font:600 22px/1.2 "Cormorant Garamond",Georgia,serif;margin:0 0 12px;letter-spacing:.01em}' +
    '.nxcn__p{font-size:14.5px;line-height:1.65;color:rgba(246,244,241,.82);margin:0 0 12px}' +
    '.nxcn__list{list-style:none;margin:16px 0 14px;padding:0;display:grid;gap:10px}' +
    '.nxcn__list li{display:flex;gap:10px;align-items:flex-start;font-size:14px;line-height:1.5;color:#f6f4f1}' +
    '.nxcn__list svg{flex:0 0 18px;margin-top:2px;color:#8be0a8}' +
    '.nxcn__fine{font-size:12px;line-height:1.55;color:rgba(246,244,241,.58);margin:0 0 20px}' +
    '.nxcn__go{display:flex;align-items:center;justify-content:center;gap:10px;width:100%;min-height:56px;border:0;border-radius:999px;background:#fff;color:#0a0a0a;font:600 13px/1 Inter,Arial,sans-serif;letter-spacing:.12em;text-transform:uppercase;cursor:pointer;-webkit-tap-highlight-color:transparent;touch-action:manipulation}' +
    '.nxcn__go:active{transform:scale(.98)}' +
    '.nxcn__back{display:block;width:100%;min-height:48px;margin-top:6px;border:0;background:none;color:rgba(246,244,241,.7);font:500 13px/1 Inter,Arial,sans-serif;cursor:pointer;text-decoration:underline;text-underline-offset:4px}' +
    '.nxcn__go:focus-visible,.nxcn__back:focus-visible{outline:2px solid #ffb27a;outline-offset:3px}' +
    '@keyframes nxcn-fade{from{opacity:0}to{opacity:1}}' +
    '@keyframes nxcn-rise{from{opacity:0;transform:translate3d(0,22px,0) scale(.98)}to{opacity:1;transform:none}}' +
    '@media(max-width:560px){.nxcn{align-items:flex-end;padding:0}.nxcn__box{max-width:none;border-radius:24px 24px 0 0;padding-bottom:calc(24px + env(safe-area-inset-bottom))}}' +
    '@media(prefers-reduced-motion:reduce){.nxcn.is-open,.nxcn__box{animation:none}}';

  var CHECK = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>';

  function build() {
    var style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    modal = document.createElement('div');
    modal.className = 'nxcn';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'nxcn-title');
    modal.innerHTML =
      '<div class="nxcn__box">' +
        '<div class="nxcn__icon" aria-hidden="true"><svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#fff" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg></div>' +
        '<h2 class="nxcn__title" id="nxcn-title">A quick note before you pay</h2>' +
        '<p class="nxcn__p">All NEXSORA payments are processed securely in <strong>Nigerian Naira (\u20A6 NGN)</strong>.</p>' +
        '<p class="nxcn__p">If you have been browsing in another currency, nothing about your price has changed. The amount you saw is the same value, shown in your currency for convenience. At checkout you will see it in \u20A6, and your bank or card provider converts it to your own currency automatically.</p>' +
        '<ul class="nxcn__list">' +
          '<li>' + CHECK + '<span>Same value. Only the currency label changes.</span></li>' +
          '<li>' + CHECK + '<span>NEXSORA adds no extra fee for currency conversion.</span></li>' +
          '<li>' + CHECK + '<span>Secure, encrypted checkout.</span></li>' +
        '</ul>' +
        '<p class="nxcn__fine">Your bank may use its own exchange rate, so the amount on your statement can differ slightly.</p>' +
        '<button type="button" class="nxcn__go" data-go>Continue to secure checkout <span aria-hidden="true">\u2192</span></button>' +
        '<button type="button" class="nxcn__back" data-back>Not yet, go back</button>' +
      '</div>';
    document.body.appendChild(modal);

    modal.addEventListener('click', function (e) { if (e.target === modal || e.target.hasAttribute('data-back')) close(); });
    modal.querySelector('[data-go]').addEventListener('click', proceed);
    modal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key === 'Tab') {
        var f = [modal.querySelector('[data-go]'), modal.querySelector('[data-back]')];
        var i = f.indexOf(document.activeElement);
        if (e.shiftKey && i <= 0) { e.preventDefault(); f[1].focus(); }
        else if (!e.shiftKey && i === 1) { e.preventDefault(); f[0].focus(); }
      }
    });
  }

  function open(trigger) {
    if (!modal) build();
    pending = trigger; lastFocus = document.activeElement;
    modal.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    modal.querySelector('[data-go]').focus();
  }
  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    pending = null;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }
  function proceed() {
    var t = pending;
    close();
    if (!t) return;
    bypass = true;
    try { t.click(); } finally { bypass = false; }
  }

  // Capture phase: runs before the page's own checkout handlers, shows the note, then replays the original click on "Continue".
  document.addEventListener('click', function (e) {
    if (bypass) return;
    var t = e.target.closest && e.target.closest(SEL);
    if (!t || t.disabled || t.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    open(t);
  }, true);
})();